import { render, staticRenderFns } from "./DriversIcon.vue?vue&type=template&id=a90f5b5e&scoped=true"
var script = {}
import style0 from "./DriversIcon.vue?vue&type=style&index=0&id=a90f5b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90f5b5e",
  null
  
)

export default component.exports